import { Injectable } from '@angular/core';
import { EmptyPropertyKey, FileSetEntryViewModel, FileStateModel, InstanceModel } from '../shared/fs.model';

@Injectable()
export class UpdateFilePropertyService {
  files: FileSetEntryViewModel[] = [];
  oldInstance: InstanceModel;
  newInstance: InstanceModel;
  oldInstanceFiles: FileStateModel[];

  constructor() { }

  updateFileProperties(files: FileSetEntryViewModel[], oldInstanceState: InstanceModel, newInstanceState: InstanceModel): void {
    this.files = files;
    this.oldInstance = oldInstanceState;
    this.newInstance = newInstanceState;
    this.oldInstanceFiles = this.oldInstance.State.FileStates;
    this.updateFileProperty('type', 'docType', EmptyPropertyKey.Type);
    this.updateFileProperty('status', 'status', EmptyPropertyKey.Status, true);
  }

  private updateFileProperty(stateKey: string, propKey: string, emptyValue: string, autoSet: boolean = false): void {
    let oldProps = this.oldInstance.State.StateProperties.find(p => p.StateKey === stateKey).StateProperties;
    let newProps = this.newInstance.State.StateProperties.find(p => p.StateKey === stateKey).StateProperties;

    this.files.forEach((file) => {
      if (newProps.length && newProps.length == 1 && autoSet) { // regardless of old property value, set to new single property
        this.updateFileState(stateKey, propKey, file[propKey], newProps[0].Key, file);
        file[propKey] = newProps[0].Key;
      } else {
        if (file[propKey] !== emptyValue) { // ignore empty properties
          let propName = oldProps.find(t => t.Key === file[propKey]).DisplayName;
          let prop = newProps.find(t => t.Key === file[propKey] || t.DisplayName === propName);
    
          if (prop) {
            if (prop.Key !== file[propKey]) { // name match, update id
              this.updateFileState(stateKey, propKey, file[propKey], prop.Key, file);
              file[propKey] = prop.Key;
            }
          } else { // property not found
            this.updateFileState(stateKey, propKey, file[propKey], emptyValue, file);
            file[propKey] = emptyValue;
          }
        }
      }
    });
  }

  private updateFileState(stateKey: string, propKey: string, oldValue: string, newValue: string, file: FileSetEntryViewModel): void {
    if (this.oldInstanceFiles && this.oldInstanceFiles.length) {
      let fileStates = this.oldInstanceFiles.filter(f => f.FileId === file.id && f.FileStateValues.find(s => s.StateKey === stateKey && s.Value === oldValue));

      if (fileStates && fileStates.length) {
        fileStates.forEach(state => {
          let fileStateValue = state.FileStateValues.find(s => s.StateKey === stateKey);
          fileStateValue.Value = newValue;
        });
      }
    }
  }
}
